import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const AddCircleIcon = (props) => (
    <SvgIcon viewBox="0 0 20 20" sx={{ height: '20px', width: 'auto', ...props }}>
        <g fill="none">
            <path
                d="M9.16878 13.3334C9.16878 13.7936 9.54187 14.1667 10.0021 14.1667C10.4624 14.1667 10.8354 13.7936 10.8354 13.3334V10.8334H13.3354C13.7957 10.8334 14.1688 10.4603 14.1688 10.0001C14.1688 9.5398 13.7957 9.16672 13.3354 9.16672H10.8354V6.66672C10.8354 6.20647 10.4624 5.83339 10.0021 5.83339C9.54187 5.83339 9.16878 6.20647 9.16878 6.66672V9.16672H6.66878C6.20854 9.16672 5.83545 9.5398 5.83545 10.0001C5.83545 10.4603 6.20855 10.8334 6.66878 10.8334H9.16878V13.3334Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.1688 10.0001C19.1688 4.93747 15.0647 0.833384 10.0021 0.833384C4.93951 0.833384 0.835449 4.93747 0.835449 10.0001C0.835449 15.0627 4.93951 19.1667 10.0021 19.1667C15.0647 19.1667 19.1688 15.0627 19.1688 10.0001ZM2.50781 10.0001C2.50781 5.86105 5.86312 2.50572 10.0021 2.50572C14.1411 2.50572 17.4965 5.86105 17.4965 10.0001C17.4965 14.139 14.1411 17.4944 10.0021 17.4944C5.86312 17.4944 2.50781 14.139 2.50781 10.0001Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="20" height="20" fill="white" transform="matrix(1 0 0 -1 0 20)" />
            </clipPath>
        </defs>
    </SvgIcon>
);

export default AddCircleIcon;
